import * as AF from "@/components/form-items/AbstractForm";
import { DoubleMultilingualField } from "@/components/form-items/MultilingualField";
import { useTranslation } from "react-i18next";

const SculptureEditionTechnicalNotesTab = () => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.RichText
        name="sculptureEditionNotesTechniques"
        label={t("sculptureEditionNotesTechniques")}
      />
      <div className="flex justify-start w-full">
        <AF.Switch
          name="sculptureEditionRemarquesPubliquesPublished"
          label={t("sculpture.form.sculptureEditionRemarquesPubliquesPublished")}
        />
      </div>
      <DoubleMultilingualField
        name="sculptureEditionRemarquesPubliquesMultilingual"
        render={(lang) => (
          <AF.RichText
            name={`sculptureEditionRemarquesPubliquesMultilingual.${lang}`}
            label={t("artwork.form.oeuvresValidationRemarquesPubliques")}
          />
        )}
      />
    </AF.Col>
  );
};

export default SculptureEditionTechnicalNotesTab;
